/**
 * StatusPill — статус проекта (в работе / завершён / приостановлен,
 * FR-3.1): точка-индикатор + подпись в капсуле. Незнакомый статус с
 * бэка выводится как есть с нейтральной точкой.
 */
import { useTranslation } from 'react-i18next';

import { cn } from '../../../lib/cn';

const DOT: Record<string, string> = {
  inProgress: 'bg-chart-indigo',
  done: 'bg-brand-500',
  paused: 'bg-status-danger',
};

export const StatusPill = ({ status }: { status: string | null }) => {
  const { t } = useTranslation();
  if (status === null) return <span className="text-text-muted">—</span>;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-surface-border px-2.5 py-0.5 text-xs',
        status === 'done' ? 'text-brand-700' : 'text-text-muted',
      )}
    >
      <span
        className={cn(
          'size-1.5 rounded-full',
          DOT[status] ?? 'bg-text-faint',
        )}
        aria-hidden="true"
      />
      {t(`projects.infrastructure.statuses.${status}`, {
        defaultValue: status,
      })}
    </span>
  );
};
